import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const UbigeoFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='UBIGEO' htmlFor='input-ubigeo' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='ubigeo'>
          {({ field }) => (
            <Form.InputText
              {...field}
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              id='input-ubigeo'
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(UbigeoFormGroup)
